import React from 'react';
import { Button, Badge } from 'react-bootstrap';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

const SortControls = ({
  currentSortField = null,
  currentSortOrder = 'DESC',
  onSortChange = () => {},
}) => {
  
  const sortOptions = [
    { field: 'created_at', label: 'Tanggal' },
    { field: 'role', label: 'Role' },
  ];

  const renderSortIcon = (field) => {
    if (currentSortField !== field) return <FaSort className="text-muted" />;
    return currentSortOrder === 'ASC' ? <FaSortUp /> : <FaSortDown />;
  };

  const handleSortClick = (field) => {
    onSortChange(field);
  };

  return (
    <div className="mb-3">
      <div className="d-flex align-items-center flex-wrap gap-2">
        <span className="text-muted">Sort by:</span>
        
        {sortOptions.map((option) => (
          <Button
            key={option.field}
            variant={currentSortField === option.field ? 'primary' : 'outline-primary'}
            size="sm"
            onClick={() => handleSortClick(option.field)}
            className="d-flex align-items-center gap-1"
          >
            {option.label} {renderSortIcon(option.field)}
          </Button>
        ))}

        {/* Current Sort Info */}
        {currentSortField && (
          <Badge bg="light" text="dark" className="ms-2">
            Sorting: {sortOptions.find(opt => opt.field === currentSortField)?.label} 
            ({currentSortOrder === 'ASC' ? 'Ascending' : 'Descending'})
          </Badge>
        )}
      </div>
    </div>
  );
};

export default SortControls;